import { CategoryType } from 'types/category'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db } from 'firebase/index'
import { push } from 'connected-react-router'

const saveCategories = (categories: CategoryType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const batch = db.batch()

    for (let i = 0; i < categories.length; i = (i + 1) | 0) {
      const category = categories[i]
      batch.set(category.category_ref, category, { merge: true })
    }

    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push('/admin/master/categories/complete'))
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default saveCategories
